import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionReservationBaseReservationType } from "./base-reservation-type";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../../store/categories";

type Props = {
	reservationRequestReservationSettings: HotelPolicyCategoriesAndManagerStore["reservationRequestReservationSettings"];
};

export const QuestionReservationRequest = ({ reservationRequestReservationSettings }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper categoryStore={reservationRequestReservationSettings}>
				<QuestionReservationBaseReservationType />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionReservationRequest.displayName = "QuestionReservationRequest";
